import React from "react";
import "./sidebars.scss";
import dashboard from "../../assets/images/dashboard.svg";
import plates from "../../assets/images/dashboard.svg";
import userManagement from "../../assets/images/user-management.svg";
import logoutIcon from "../../assets/images/logout.svg";
import User from "../../assets/images/user.svg";
import Arrow from "../../assets/images/chevron-right.svg";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

function getDisplayName(user) {
  if (!user) return "Admin";
  const first = user.firstName ?? "";
  const last = user.lastName ?? "";
  const full = [first, last].filter(Boolean).join(" ");
  if (full) return full;
  return user.name || user.fullName || user.email || "Admin";
}

export const Sidebars = ({ toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const displayName = getDisplayName(user);
  const profileImage =
    user?.profilePictureUrl || user?.profileImage || user?.image || User;

  const handleClick = () => {
    if (window.innerWidth <= 768) toggleSidebar();
  };

  const handleMainMenuClick = () => {
    handleClick(); // Mobile auto-close
  };

  const handleLogout = () => {
    // Call the logout function from useAuth which handles all cleanup
    logout();
    // Navigate to login page
    navigate("/login", { replace: true });
  };

  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === "/") return currentPath === "/";
    return currentPath.startsWith(path);
  };

  return (
    <Sidebar>
      <div className="menu-wrapper">
        <div className="logo-wrapper">
          <div className="logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="logo" />
          </div>
          <div className="cross" onClick={toggleSidebar}>
            <img src={process.env.PUBLIC_URL + "/images/cross.svg"} alt="cross" />
          </div>
        </div>
        <Menu>
          {/* Dashboard */}
          <MenuItem
            onClick={handleMainMenuClick}
            component={<Link to="/" />}
            className={isActive("/") ? "active-link" : ""}
          >
            <img src={dashboard} alt="icon" />
            <p>Dashboard</p>
          </MenuItem>

          {/* Plates Management */}
          <MenuItem
            onClick={handleMainMenuClick}
            component={<Link to="/plates-management" />}
            className={isActive("/plates-management") ? "active-link" : ""}
          >
            <img src={plates} alt="icon" />
            <p>Plates Management</p>
          </MenuItem>

          {/* User Management */}
          <MenuItem
            onClick={handleMainMenuClick}
            component={<Link to="/user-management" />}
            className={isActive("/user-management") ? "active-link" : ""}
          >
            <img src={userManagement} alt="icon" />
            <p>User Management</p>
          </MenuItem>
        </Menu>
        <div className="account-settings">
          <Link to="/account-settings">
            <div className="name">
              <img
                src={profileImage}
                alt="profile"
                className="sidebar-profile-img"
                onError={(e) => {
                  e.target.src = User;
                }}
              />
              <div className="info">
                <p>{displayName}</p>
                <span>Admin</span>
              </div>
            </div>
            <div className="arrow">
              <img src={Arrow} alt="arrow" />
            </div>
          </Link>
        </div>
      </div>

      {/* Logout button */}
      <div className="logout-section">
        <button className="logout-btn" onClick={handleLogout}>
          <img src={logoutIcon} alt="logout" />
          <span>Log out</span>
        </button>
      </div>
    </Sidebar>
  );
};
